// eslint-disable-next-line no-shadow
export enum ORIENTATION {
    HORIZONTAL = "horizontal",
    SQUARE = "square",
  }

export interface FallbackAdStyle {
    containerSize: string;
    iframeStyle: string;
  }

export interface FallbackAdConfig {
    url: string;
    uid: string;
  }

export interface FallbackAdURL {
    orientation: string;
    creativeID: string;
    lineID: string;
    orderID?: string;
    adUnit?: string;
  }

export interface TaglessAdStyle {
  iframeStyle: string;
}
